<template>
  <div id="dep" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_case"></div>
    <div class="container case-message" style="max-width: 1000px;min-height: calc(100vh - 553px);">
      <el-row :gutter="50">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="organ mess" style="margin: 50px 0 0 0;">
            <el-link :underline="false" v-if="data[0]">{{data[0].name}}</el-link>
          </div>
        </el-col>
      </el-row>
      <el-divider class="space"></el-divider>
      <div class="depcontent" v-if="data[0]" v-html="data[0].content" style="margin: 30px  0!important;">
        {{data[0].content}}</div>
      </el-row>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'organ',
    components: {
      navheader,
      fixheader,
      filing
    },
    data() {
      return {
        depTitle: "",
        depEtitle: "",
        depContent: "",
        depInformation: "",
        arrDataContent: [],
        data: [],
        img: [],
        xs: 24,
        type: "",
        isActive: false
      }
    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
      this.type = this.$route.query.type;
      this.content();
    },
    created() {},
    methods: {
      content() {

        this.axios.get(this.$http + "/api/index/getDepcontents", {
            params: {
              id: this.type
            }
          })
          .then((res) => {
            this.data = res.data.data;
            console.log(this.data);
          })
          .catch((err) => {})
      }
    }
  }
</script>

<style>
  .con .case-message .el-tabs__active-bar {
    width: 56px !important;
  }

  .con .case-message .organ .el-row .el-col .el-card {
    height: 175px;
    min-height: 175px;
  }

  .con .case-message .el-col {
    margin: 10px 0 !important;
  }

  #dep .organ .el-row .el-col .el-card {
    height: auto !important;
    max-height: 5000px !important;
  }

  #dep .hideclass {
    overflow: inherit !important;
    height: auto !important;
  }

  #dep div.space {
    height: 3px !important;
    position: relative;
  }

  #dep div.space:before {
    position: absolute;
    content: "";
    top: 0;
    width: 160px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.6);
    right: calc(50% - 80px);
  }

  #dep .el-card__body {
    text-align: center !important;
  }

  #dep .box-set {
    min-height: 320px !important;
    overflow: hidden;
    padding: 10px 15px !important;
  }

  #dep .box-set img {
    height: 320px;
    width: auto;
  }

  #dep .organmess {
    text-indent: 2em;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.7);
    margin: 30px 0 80px 0;
    font-size: 16px;
  }

  #dep img.boder-con {
    border: 1px solid rgba(0, 0, 0, 0.3);
  }

  #dep .img-height {
    height: 400px;
    overflow: hidden;
  }

  #dep .img-height img {
    height: 100%;
  }

  #dep .depcontent table {
    width: 100% !important;
    text-align: center !important;
    margin: 30px 0;
  }

  #dep .depcontent {
    /* font-family: "SourceHanSerifCN" !important; */
    font-size: 16px !important;
    color: #636363;
    line-height: 3.0;
  }

  #dep .depcontent table img,
  #dep .depcontent img {
    border: 1px solid rgba(0, 0, 0, 0.7);
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_dep.vue